// extracted by mini-css-extract-plugin
export default {"color-hot-tamales":"#F9302D","colorHotTamales":"#F9302D","root":"MPkIU","icon":"_1--P_"};